export default __webpack_public_path__ + "static/media/ready-icon.80a4da03.svg";